import { MapIcon } from "@heroicons/react/24/solid";
import { useState, useCallback, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router";
import ReactTooltip from "react-tooltip";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import AddButton from "../../../../components/AddButton";
import DownloadButton from "../../../../components/DownloadButton";
import { Button } from "../../../../components/buttons";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import EditButton from "../../../../components/EditButton";
import { Flex } from "../../../../components/layouts";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { mainSelectedTab, onCloseSetPage } from "../../atoms";
import { CarrierAgreementMgmtTabs } from "../../carrierAgreementTabs";
import { employeeFromOfficeHierarchy } from "../../Employees/Confie/atoms/atoms";
import { CSVLink } from "react-csv";
import {
  setOfficeHierarchyRowForEdit,
  addHierarchyState,
  empHierarchyState,
  hierarchyTypeState,
  officeHierarchyModalState,
  officeHierarchyOnCloseState,
  officeHierarchyOnShowState,
  officeHierarchyRecordTypeModalState,
  officeHierarchyRecordTypeState,
  selectedRowsStateToDeleteOF,
  recordIdToShowInTS,
  dataId,
  showTable,
} from "../atoms/atoms";
import OfficeHierarchyForm from "../forms/OfficeHierarchyForm";
import useDeleteOfficeHierarchy from "../hooks/useDeleteOfficeHierarchy";
import { useOfficeHierarchy } from "../hooks/useOfficeHierarchy";
import { OfficeHierarchyFormModal } from "../modals/OfficeHierarchyFormModal";
import { RecordTypeModal } from "../modals/RecordTypeModal";
import OfficeHierarchyView from "../views/OfficeHierachyView";
import { toast } from "../../../../components/toastNotification";
import { useQueryClient } from "react-query";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import MaterialTableEmp from "../../../../components/tables/MaterialTableEmp";
import useSendEmail from "../hooks/useSendEmail";
import ViewOHButton from "../../../../components/buttons/ViewOHButton";
import OfficeHierarchyOrgCharts from "./OfficeHierarchyOrgChart/OfficeHierarchyOrgChartTabs";

const OfficeHierarchyTable = () => {
  const queryClient = useQueryClient();
  const [ohIdData, setOHIdData] = useRecoilState<any>(dataId);
  const [searchId, setSearchId] = useState("");
  const [isParent, setIsParent] = useState(false);
  const [selectedRows] = useState([]);
  const tableRef = useRef<any>();

  const [officeHierarchyId, setOfficeHierarchyId] = useState(0);
  //RecoilStates
  const setSelectedIndex = useSetRecoilState(mainSelectedTab);
  const [, setViewFromHierarchy] = useRecoilState(employeeFromOfficeHierarchy);
  const [showRecordTypeModal, setShowRecordTypeModal] = useRecoilState(
    officeHierarchyRecordTypeModalState
  );
  const [recordIdFromLoc, setRecordIdFromLoc] =
    useRecoilState(recordIdToShowInTS);
  const [showState, setShowState] = useRecoilState(officeHierarchyOnShowState);
  const [recordType, setRecordType] = useRecoilState(
    officeHierarchyRecordTypeState
  );
  const [, setHierarchyType] = useRecoilState(hierarchyTypeState);
  const [, setOpenOfficeHierarchyForm] = useRecoilState(
    officeHierarchyOnCloseState
  );
  const [showOfficeHierarchyModalState, setShowOfficeHierarchyModalState] =
    useRecoilState(officeHierarchyModalState);
  const [, setEditState] = useRecoilState(empHierarchyState);
  const [, setAddState] = useRecoilState(addHierarchyState);
  const setRowToEdit = useSetRecoilState(setOfficeHierarchyRowForEdit);
  const [oHExportData, setOHExportData] = useState([]);
  const [isLinked, setIsLinked] = useState(false);
  const [selectedRowsToDelete, setSelectedRowsToDelete] = useRecoilState(
    selectedRowsStateToDeleteOF
  );
  const [hasActiveAssociatefOffice, setHasActiveAssociatedOffice] =
    useState<any>();
  const [hasActiveRelatedHierarchies, setHasActiveRelatedHierarchies] =
    useState<any>();
  const addPermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_officehierarchy_add;
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const employeeViewPermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_employee_view;
  const [closeSetPage] = useRecoilState<any>(onCloseSetPage);
  const [isDownloading, setIsDownloading] = useState(false);
  const [filteredData, setFilteredData] = useState();
  const [tableShow, setTableShow] = useRecoilState(showTable);
  const [, setOrgChartShow] = useState(true);
  const [isFromEmpTable, setFromEmpTable] = useState(false);
  const [ohEditData, setOhEditData] = useState<any>();

  //Datas
  const { data: dataOfficeHierarchy, isFetching } = useOfficeHierarchy();

  //Permission
  const userPermissions = useRecoilValue(permissionsSelector);
  const deletePermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_officehierarchy_delete;
  const editPermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_officehierarchy_edit;

  const onClickOfficeHierarchyName = (rowData, isParent = false) => {
    setShowState(true);
    setOHIdData(rowData?.officeHierarchyId);
    setIsParent(isParent);
    setOhEditData(rowData);
    localStorage.setItem("ohIdRedirect", rowData?.officeHierarchyId);
    localStorage.setItem("page", tableRef?.current?.state?.currentPage);
    localStorage.setItem("officeId", recordIdFromRecent?.officeId);
  };

  const {
    mutate: BulkDeleteOfcHierarchy,
    isSuccess: deacSuccess,
    data: deacResult,
    reset: resetDeacData,
  } = useDeleteOfficeHierarchy();

  let location = useLocation();
  const history = useHistory();
  const search = location.pathname;
  const qs = new URLSearchParams(search);
  const qsId = qs.get("officeHierarchyId");
  if (qsId && searchId === "") {
    setSearchId(qsId);
  }

  let recordIdFromRecent;
  let pages = localStorage.getItem("page");
  if (location.state != null) {
    recordIdFromRecent = location.state;
  }

  useEffect(() => {
    setTableShow(
      recordIdFromRecent?.action === "OfficeCancel" ||
        recordIdFromRecent?.action === "RedirectToOfficeHierarchy"
        ? true
        : false
    );
  }, []);

  const handleLink = (moduleName, idEmployee, fromOHId = null) => {
    const url = "/carrieragreementmgmt/employee";
    history.push({
      pathname: `/carrieragreedmentmgmt/employee?actionFrom=OfficeHierarchy${
        fromOHId
          ? "View&employeenumber=" +
            idEmployee +
            "&officehierarchyid=" +
            fromOHId
          : "&employeenumber=" + idEmployee
      }`,
    });
    let userTabs = [
      {
        to: "",
      },
    ];
    [...CarrierAgreementMgmtTabs].forEach((tabs) => {
      let temp = [...userPermissions].filter(
        (user) => user === tabs.permission
      );
      if (temp.length > 0) userTabs.push(tabs);
    });
    userTabs.shift();
    const index = userTabs.findIndex((c) => c.to === url);
    setViewFromHierarchy(true);
    setSelectedIndex(index);
  };
  if (
    dataOfficeHierarchy?.length > 0 &&
    recordIdFromRecent?.action === "OfficeCancel"
  ) {
    tableRef.current.dataManager!.currentPage = recordIdFromRecent?.prevPage;
    if (!isFetching) {
      setTimeout(() => {
        history.replace("");
      }, 2000);
    }
  }
  if (
    dataOfficeHierarchy?.length > 0 &&
    recordIdFromRecent?.action === "NsaOrgChartCancel"
  ) {
    if (!isFetching) {
      setTimeout(() => {
        history.replace("");
      }, 2000);
    }
  }
  if (
    dataOfficeHierarchy?.length > 0 &&
    recordIdFromRecent?.action === "SplcOrgChartCancel"
  ) {
    if (!isFetching) {
      setTimeout(() => {
        history.replace("");
      }, 2000);
    }
  }

  if (
    dataOfficeHierarchy?.length > 0 &&
    recordIdFromRecent?.action === "SalesOrgChartCancel"
  ) {
    if (!isFetching) {
      setTimeout(() => {
        history.replace("");
      }, 2000);
    }
  }
  if (dataOfficeHierarchy?.length > 0 && pages && closeSetPage) {
    // tableRef.current.dataManager!.currentPage = Number(pages);
    if (!isFetching) {
      setTimeout(() => {
        localStorage.removeItem("page");
      }, 2000);
    }
  }

  const onClickEmployee = (rowdata) => {
    const url = "/officesettings/officehierarchy";
    history.push({
      pathname: "/employeetab/employee",
      state: {
        employeeId: rowdata.idEmployee,
        action: "RedirectToEmployee",
        prevPage: tableRef?.current?.state?.currentPage,
      },
    });

    window.location.reload();

    let userTabs = [
      {
        to: "",
      },
    ];
    [...OfficeTabs].forEach((tabs) => {
      let temp = [...userPermissions].filter(
        (user) => user === tabs.permission
      );
      if (temp.length > 0) userTabs.push(tabs);
    });
    userTabs.shift();
    const index = userTabs.findIndex((c) => c.to === url);
    setViewFromHierarchy(true);
    setSelectedIndex(index);
  };
  useEffect(() => {
    setShowState(false);
    let actionFrom = new URLSearchParams(window.location.search).get(
      "actionFrom"
    );
    if (recordIdFromRecent?.action === "OHFromOfficeSetting") {
      onClickOfficeHierarchyName(
        dataOfficeHierarchy?.filter(
          (x) => x.officeHierarchyId === recordIdFromRecent?.officeHierarchyId,
          false
        )
      );
      setFromEmpTable(recordIdFromRecent?.fromEmpTable);
      setIsLinked(true);
      setOHIdData(recordIdFromRecent?.officeHierarchyId);
      setShowState(true);
    }
    if (recordIdFromLoc !== 0) {
      if (recordIdFromLoc?.toString()?.includes(".")) {
        let officeHierarchyIds = recordIdFromLoc?.toString().split(".");
        const officeHierarchyArr = officeHierarchyIds.map((id) => Number(id));
        const filteredData = dataOfficeHierarchy?.filter((x) =>
          officeHierarchyArr.includes(x.officeHierarchyId)
        );
        setFilteredData(filteredData);
      } else {
        onClickOfficeHierarchyName(
          dataOfficeHierarchy?.filter(
            (x) => x.officeHierarchyId === recordIdFromLoc,
            false
          )
        );
        setOHIdData(recordIdFromLoc);
        setShowState(true);
      }

      setRecordIdFromLoc(0);
    }
    if (actionFrom === "OHFromOfficeSettingCancel") {
      onClickOfficeHierarchyName(
        dataOfficeHierarchy?.filter(
          (x) => x.officeHierarchyId === Number(searchId),
          false
        )
      );
      setIsLinked(false);
      setOHIdData(searchId);
      setShowState(true);
    }

    if (recordIdFromRecent?.action === "RedirectToOfficeHierarchy") {
      const id = localStorage.getItem("ohIdFromOffice");
      const idFromRedirect = localStorage.getItem("ohIdRedirect");

      setIsLinked(false);
      setOHIdData(
        id !== null ? id : idFromRedirect !== undefined ? idFromRedirect : null
      );
      setShowState(true);
    }
    if (actionFrom === "Employee") {
      onClickOfficeHierarchyName(
        dataOfficeHierarchy?.filter(
          (x) => x.officeHierarchyId === Number(searchId),
          false
        )
      );
      setIsLinked(false);
      setOHIdData(searchId);
      setShowState(true);
      history.push({
        pathname: `/officesettings/officehierarchy`,
      });
    }
  }, []);
  const CancelLink = () => {
    if (isLinked) {
      setIsLinked(false);
      const url = "/officesettings/officesetting";
      let prevPage = new URLSearchParams(window.location.search).get(
        "prevPage"
      );
      /// For Digital Assets
      if (prevPage) {
        history.push({
          pathname: "/officesettings/officesetting?prevPage=" + prevPage,
          state: {
            officeId: recordIdFromRecent?.officeId,
            action: "OfficeHierarchyCancel",
          },
        });
      } else {
        history.push({
          pathname: "/officesettings/officesetting",
          state: {
            officeId: recordIdFromRecent?.officeId,
            action: "OfficeHierarchyCancel",
            fromEmpTable: isFromEmpTable,
          },
        });
      }

      let userTabs = [
        {
          to: "",
        },
      ];
      [...CarrierAgreementMgmtTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      userTabs.shift();
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setIsLinked(false);
      setOHIdData(0);
      setShowState(false);
    }
  };
  const handleEdit = (rowDetails) => {
    setRowToEdit({
      ...rowDetails,
      name: rowDetails.officeHierarchyName
        ? rowDetails.officeHierarchyName
        : "",
      type: rowDetails.type ? rowDetails.type : null,
      owner: rowDetails.createdBy ? rowDetails.createdBy : "",
      parentHierarchyId: rowDetails.parentHierarchyId
        ? Number(rowDetails.parentHierarchyId)
        : "",
      managerEmployeeId: rowDetails.idEmployee ? rowDetails.idEmployee : null,
      managerEffectiveDate:
        rowDetails?.managerEffectiveDate !== null
          ? new Date(rowDetails.managerEffectiveDate)
              .toISOString()
              .split("T")[0]
          : rowDetails?.managerEffectiveDate,
      isActive: rowDetails?.isActive ? true : false,
      code: rowDetails.hierarchyCode ? rowDetails.hierarchyCode : "",
      associatedOffices: ohEditData
        ? ohEditData?.associatedOffices
        : rowDetails.associatedOffices,
      relatedHierarchies: ohEditData
        ? ohEditData?.relatedHierarchies
        : rowDetails.relatedHierarchies,
    });
    setShowOfficeHierarchyModalState(true);
  };

  const alignCenter = "center" as
    | "center"
    | "inherit"
    | "justify"
    | "left"
    | "right"
    | undefined;

  const handleBulkDelete = () => {
    if (
      hasActiveAssociatefOffice?.length === 0 &&
      hasActiveRelatedHierarchies?.length === 0
    ) {
      const ids = selectedRowsToDelete;
      BulkDeleteOfcHierarchy(ids);
      setOpenModalDelete(false);
    } else {
      setOpenModalDelete(false);
    }
  };

  const { mutateAsync: sendEmail } = useSendEmail();

  if (deacSuccess && deacResult) {
    if (deacResult.status === 201 || deacResult.status === 200) {
      toast.fire(
        "Success",
        "Office Hierarchy were deactivated successfully",
        "success"
      );
      // var item;
      deacResult.data.forEach((item) => {
        sendEmail(item);
      });
      queryClient.invalidateQueries("GetOfficeHierarchy");
      setSelectedRowsToDelete([]);
    } else if (deacResult.status === 500) {
      if (
        deacResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available" ||
        deacResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available"
      ) {
        toast.fire(
          "Warning",
          "Office Hierarchy were successfully deactivated, but " +
            deacResult.data.message,
          "warning"
        );
        setSelectedRowsToDelete([]);
      } else {
        toast.fire(
          "Bulk deactivation of Office Hierarchy failed",
          "Server Error: Cannot deactivate Office Hierarchy",
          "error"
        );
      }

      queryClient.invalidateQueries("GetOfficeHierarchy");
    } else {
      toast.fire(
        "Bulk deactivation of Office Hierarchy failed",
        "Server Error: Cannot deactivate Office Hierarchy",
        "error"
      );
      queryClient.invalidateQueries("GetOfficeHierarchy");
    }
    resetDeacData();
  }
  const handleSelectedRowsChange = useCallback((rows) => {
    const forDelete = rows
      .filter((x) => x.isActive)
      .map((r) => {
        const { tableData, ...rows } = r;
        return rows;
      });

    setSelectedRowsToDelete(forDelete?.map((x) => x.officeHierarchyId));

    //get active offices
    const associate = forDelete?.flatMap((x) => x.associatedOffices);
    if (associate) {
      const offices = associate?.filter(
        (x) => x !== null && !x.officeStatusName?.includes("Closed")
      );
      setHasActiveAssociatedOffice(offices);
    }

    // get related active hierarchies
    const relatedHierarchies = forDelete?.flatMap((x) => x.relatedHierarchies);
    if (relatedHierarchies) {
      const related = relatedHierarchies?.filter(
        (x) => x !== null && x.isActive === true
      );
      setHasActiveRelatedHierarchies(related);
    }
  }, []);

  const columns = [
    {
      title: "Name",
      field: "officeHierarchyName",
      customSort: (a, b) => {
        // Handle null/undefined
        const officeHierarchyNameA = a.officeHierarchyName?.toLowerCase() || "";
        const officeHierarchyNameB = b.officeHierarchyName?.toLowerCase() || "";

        // If officeHierarchyName is empty, consider it as the smallest value (comes last in descending order)
        if (officeHierarchyNameA > officeHierarchyNameB) return 1;
        if (officeHierarchyNameA < officeHierarchyNameB) return -1;
        return 0;
      },
      render: (rowdata) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => {
              onClickOfficeHierarchyName(rowdata, false);
            }}
          >
            <span className="blueAndBold underline">
              {rowdata.officeHierarchyName}
            </span>
          </div>
        );
      },
    },
    {
      title: "Type",
      field: "type",
    },

    {
      title: "Manager",
      field: "managerName",
      render: (rowdata) => {
        return (
          <div>
            <ReactTooltip place="right" effect="solid" type="info" />
            {userPermissions.includes(employeeViewPermission) ? (
              rowdata.managerName !== "" ? (
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    onClickEmployee(rowdata);
                  }}
                >
                  <span className="blueAndBold underline">
                    {rowdata.managerName}
                  </span>
                </div>
              ) : (
                rowdata.managerName
              )
            ) : (
              <div
                data-tip={
                  "Contact your System Administrator to secure access to employee module."
                }
                className="cursor-pointer"
              >
                <span className="blueAndBold underline">
                  {rowdata.managerName}
                </span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "Code",
      field: "hierarchyCode",
      customSort: (a, b) => {
        // Handle null/undefined
        const hierarchyCodeA = a.hierarchyCode?.toLowerCase() || "";
        const hierarchyCodeB = b.hierarchyCode?.toLowerCase() || "";

        // If hierarchyCode is empty, consider it as the smallest value (comes last in descending order)
        if (hierarchyCodeA > hierarchyCodeB) return 1;
        if (hierarchyCodeA < hierarchyCodeB) return -1;
        return 0;
      },
      render: (rowData) => {
        return (
          <div>
            <span className="blackAndBold text-xs">
              {rowData.hierarchyCode}
            </span>
          </div>
        );
      },
    },
    {
      title: "Status",
      field: "isActive",
      render: (rowData) => {
        return <div>{rowData.isActive ? "Active" : "Inactive"}</div>;
      },
      customFilterAndSearch: (term, rowData) => {
        // Handle case-insensitivity
        const searchTerm = term.toLowerCase();

        // Return true if search matches "active" or "inactive"
        if (searchTerm === "active" && rowData.isActive) return true;
        if (searchTerm === "inactive" && !rowData.isActive) return true;

        return false;
      },
    },
    {
      title: "Action",
      sorting: false,
      align: alignCenter,
      render: (rowDetails) => {
        return userPermissions.includes(editPermission) ? (
          <div className="flex place-content-center">
            <EditButton
              className={selectedRows.length > 0 ? "opacity-50" : "opacity-100"}
              disabled={selectedRows.length > 0 ? true : false}
              buttonText="Edit"
              onClick={() => {
                // setDisableLoading(false);
                setOfficeHierarchyId(rowDetails.officeHierarchyId);
                setEditState(true);
                handleEdit(rowDetails);
              }}
            />
          </div>
        ) : (
          ""
        );
      },
    },
  ];
  const deleteMessage = (
    <div className="text-gray-500 font-normal">
      {hasActiveAssociatefOffice?.length > 0 ||
      hasActiveRelatedHierarchies?.length > 0
        ? `The releated hierarchies are still active. To deactivate, please modify the hierarchy to remove it's associations and assign new hierarchy.`
        : `Are you sure you want to deactivate ${
            selectedRowsToDelete?.length
          } ${
            selectedRowsToDelete
              ? selectedRowsToDelete?.length > 1
                ? "Office Hierarchies"
                : "Office Hierachy"
              : ""
          }?`}
    </div>
  );
  let dateTimeToday = new Date(new Date().toISOString()).toISOString();

  const mapExportData = (exportData) => {
    if (exportData) {
      setOHExportData(
        exportData?.map((x) => {
          {
            return {
              Id: x.officeHierarchyId,
              Name: x.officeHierarchyName,
              Type: x.type,
              Code: x.hierarchyCode,
              Status: x.isActive ? "Active" : "Inactive",
              Description: x.description?.includes("\n")
                ? x.description.replaceAll("\n", "")
                : x.description,
              Owner: x.createdBy,
              "Parent Hierarchy": x.parentHierarchy,
              "Parent Hierarchy Id": x.parentHierarchyId,
              "District Code": x.districtCode,
              "Region Code": x.regionCode,
              "Area Code": x.areaCode,
              "Territory Code": x.territoryCode,
              "Record Type": x.type.toLowerCase() == "district" ? x.type : "",
              Manager: x.managerName,
              "Manager Phone Number": x.managerPhoneNumber,
              "Manager Email": x.managerEmail,
              "Employee ID": x.employeeId,
              "Manager Effective Date": x.managerEffectiveDate
                ? new Date(x.managerEffectiveDate)?.toLocaleDateString()
                : "",
              "Previous Manager": x.previousManager,
              "Sales President": x.salesPresident,
              "Sales President Email": x.salesPresidentEmail,
              "Sales President Phone": x.salesPresidentPhoneNumber,
              "Sale VP": x.salesVp,
              "Sale VP Email": x.salesVPEmail,
              "Sales VP Phone": x.salesVPPhoneNumber,
              "Last Modified By": x.updatedBy,
              "Last Modified Date": x.updatedOn
                ? new Date(x.updatedOn)?.toLocaleDateString()
                : "",
              "Created By": x.createdBy,
              "Created Date": x.createdOn
                ? new Date(x.createdOn)?.toLocaleDateString()
                : "",
            };
          }
        })
      );
      setTimeout(() => {
        toast.fire(
          "Download Office Hierarchy Reports",
          "Office Hierarchy reports downloaded successfully.",
          "success"
        );
        setIsDownloading(false);
      }, 2000);
    }
  };

  const csvReport = {
    filename: "OfficeHierarchyReport" + dateTimeToday + ".csv",
    data: oHExportData ? oHExportData : [],
  };
  return (
    <>
      <RecordTypeModal
        isOpen={showRecordTypeModal}
        onClose={() => {
          setShowRecordTypeModal(false);
        }}
      >
        <div>
          <Flex className="space-x-2 justify-end w-full">
            <Button
              variant="lightGray"
              // className="bg-gray-100 mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
              type="button"
              size="sm"
              onClick={() => {
                setHierarchyType("");
                setRecordType("");
                setShowRecordTypeModal(false);
              }}
            >
              Cancel
            </Button>
            <Button
              // className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
              type="button"
              size="sm"
              disabled={recordType ? false : true}
              onClick={() => {
                setAddState(true);
                // setHierarchyType(recordType);
                setOfficeHierarchyId(0);
                setShowRecordTypeModal(false);
                setOpenOfficeHierarchyForm(true);
                setShowOfficeHierarchyModalState(true);
              }}
            >
              Next
            </Button>
          </Flex>
        </div>
      </RecordTypeModal>
      {showOfficeHierarchyModalState && (
        <OfficeHierarchyFormModal
          isOpen={showOfficeHierarchyModalState}
          hasCloseButton={false}
          // size="5xl"
          width="4/5"
          className="border"
        >
          {/* <AddEditOfficeHierarchyForm id={officeHierarchyId} /> */}
          {showOfficeHierarchyModalState && (
            <OfficeHierarchyForm
              id={officeHierarchyId}
              setIsAdd={setAddState}
              setIsEdit={setEditState}
              recordOption={recordType}
              setOfficeHierarchyId={setOfficeHierarchyId}
              dataOfficeHierarchy={dataOfficeHierarchy}
            />
          )}
        </OfficeHierarchyFormModal>
      )}
      {!showState && (
        <div className="pt-4 px-8 bg-white min-h-fit">
          <div>
            <div className="flex gap-2 items-center">
              <div>
                <MapIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
              </div>
              <div className="flex flex-col leading tight">
                <h3 className="text-xs font-medium text-gray-500">
                  Office Hierarchy
                </h3>
                <h1 className="mr-auto font-bold text-primary text-md uppercase">
                  All Office Hierarchy Information
                </h1>
              </div>
            </div>
          </div>
          <div className="flex flex-row gap-2 justify-between items-center">
            {userPermissions.includes(editPermission) && tableShow === true && (
              <div className="text-secondary italic text-xs3 my-2">
                <p className="font-bold italic inline-block mr-1">Note: </p>
                Tick the box to deactivate some data.
              </div>
            )}
            <div className="gap-2 flex items-center float-right ml-auto">
              {!tableShow ? (
                <ViewOHButton
                  className={"opacity-100"}
                  disabled={false}
                  buttonText="View as Table"
                  onClick={() => {
                    setOrgChartShow(false);
                    setTableShow(true);
                    history.push("/officesettings/officehierarchy");
                  }}
                />
              ) : (
                <ViewOHButton
                  className={"opacity-100"}
                  disabled={false}
                  buttonText="View as Organizational Chart"
                  onClick={() => {
                    setTableShow(false);
                    setOrgChartShow(true);
                  }}
                />
              )}
              {userPermissions.includes(addPermission) && (
                <AddButton
                  className={"opacity-100"}
                  disabled={false}
                  buttonText="Add"
                  onClick={() => {
                    setShowRecordTypeModal(true);
                  }}
                />
              )}
              {!showState && !tableShow ? (
                ""
              ) : (
                <div>
                  <CSVLink {...csvReport}>
                    <DownloadButton
                      disabled={isDownloading ? true : false}
                      buttonValue={
                        isDownloading ? "Downloading..." : "Download File"
                      }
                      onClick={() => {
                        setIsDownloading(true);
                        mapExportData(
                          tableRef &&
                            tableRef.current.dataManager.searchedData.length > 0
                            ? tableRef.current.dataManager.searchedData
                            : dataOfficeHierarchy
                        );
                      }}
                    />
                  </CSVLink>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {!showState && !tableShow ? (
        <>
          <OfficeHierarchyOrgCharts />
        </>
      ) : (
        <main className={`${!showState ? "block" : "hidden"} flex flex-row`}>
          <div className={"w-full h-5/6 bg-white pt-2 pb-8 px-8"}>
            <div className="grid grid-row">
              <MaterialTableEmp
                data={filteredData ? filteredData : dataOfficeHierarchy}
                columns={columns}
                isLoading={isFetching}
                searchFieldAlignment={"left"}
                selectedRows={selectedRowsToDelete}
                toolbar={true}
                search={true}
                showTitle={false}
                tableRef={tableRef}
                exportButton={false}
                selection={userPermissions.includes(deletePermission)}
                title={"OfficeHierarchy_" + new Date().toLocaleDateString()}
                onSelectionChange={handleSelectedRowsChange}
                setOpenModal={setOpenModalDelete}
                actions={undefined}
                editable={undefined}
                grouping={undefined}
                detailPanel={undefined}
                toolBarComponent={undefined}
                panelWidth={undefined}
                onSearchChange={undefined}
                fileName={undefined}
                options={{
                  toolbar: false,
                  showTitle: false,
                  initialPage: 0,
                }}
              />
            </div>
          </div>
        </main>
      )}
      {showState && (
        <OfficeHierarchyView
          setOfficeHierarchyId={ohIdData}
          isParent={isParent}
          onClickOfficeHierarchyName={onClickOfficeHierarchyName}
          handleEdit={handleEdit}
          isLinked={isLinked}
          CancelLink={CancelLink}
          dataOfficeHierarchy={dataOfficeHierarchy}
        />
      )}
      <ConfirmBoxDelete
        ModalTitle="Deactivate Office Hierachy"
        qConfirmation={deleteMessage}
        isOpen={openModalDelete}
        onClose={() => setOpenModalDelete(false)}
        onClickFunction={handleBulkDelete}
        cancelButtonRef={undefined}
      />
    </>
  );
};

export default OfficeHierarchyTable;
